import { lazy } from "lazy-var";

const lazyJqm = lazy(async () => {
    const jqm = await import("../../../scripts/jqModal.js");
    return jqm;
});

export async function getJqm() {
    return await lazyJqm.get();
}
